var React = require('react');

function TwoCircles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M46.8333 27.9993C46.8333 40.3106 36.5966 50.3327 23.9167 50.3327C11.2367 50.3327 1 40.3106 1 27.9993C1 15.6881 11.2367 5.66602 23.9167 5.66602C36.5966 5.66602 46.8333 15.6881 46.8333 27.9993Z","stroke":"#404040","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M55.0003 27.9993C55.0003 40.3106 44.7636 50.3327 32.0837 50.3327C19.4037 50.3327 9.16699 40.3106 9.16699 27.9993C9.16699 15.6881 19.4037 5.66602 32.0837 5.66602C44.7636 5.66602 55.0003 15.6881 55.0003 27.9993Z","stroke":"#FFCB08","strokeWidth":"2","key":1})]);
}

TwoCircles.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = TwoCircles;

TwoCircles.default = TwoCircles;
